import React from 'react';
import { SeparatorStyled, SeparatorTextStyled } from '@yme/atoms/separator/styled';
export const Separator = ({ text }) => {
    return (React.createElement(SeparatorStyled, null,
        React.createElement(SeparatorTextStyled, null, text)));
};
Separator.displayName = 'Separator_Component';
